import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { isMobile } from '../../../utils/utils';
import { reemplazarCarrito } from '../../../redux/carrito/carritoSlice';
import { buildItemsQuery } from '../../../utils/carritoCompartido';

interface ProductoAttributes {
  precioFinal: number;
  [key: string]: unknown;
}

interface CarritoItem {
  cantidad: number;
  producto: {
    id: number;
    attributes: ProductoAttributes;
  };
}

const useHook = ({ sharedCartItems = [] }: { sharedCartItems?: CarritoItem[] } = {}) => {

  const dispatch = useDispatch();
  const router = useRouter();
  const carrito = useSelector((state: { carrito: { productos: CarritoItem[] } }) => state.carrito.productos);
  const [mobile, setMobile] = useState(true);
  // Arranca en `true` para que el primer render del cliente coincida con el
  // del server (que no tiene acceso al carrito en localStorage) y recién
  // muestre los productos reales después del montaje, evitando el mismatch.
  const [loadingProductos, setLoadingProductos] = useState(true);
  const [productos, setProductos] = useState<CarritoItem[]>([]);
  const [total, setTotal] = useState(0);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const calcularTotal = (items: CarritoItem[]) => {
    const suma = items.reduce((acc, item) => acc + item.cantidad * item.producto.attributes.precioFinal, 0);
    setTotal(suma);
  };

  useEffect(() => {
    setMobile(isMobile());
    setProductos(carrito);
    calcularTotal(carrito);
    setLoadingProductos(false);
  }, [carrito]);

  useEffect(() => {
    if (sharedCartItems.length > 0) {
      dispatch(reemplazarCarrito(sharedCartItems));
      router.replace(router.pathname, undefined, { shallow: true });
    }
    // Se aplica una sola vez al montar: si no se limpiara el query param `items`
    // de la URL, un refresh volvería a disparar el reemplazo y borraría
    // cualquier cambio que el usuario haya hecho después de abrir el link.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const compartirCarrito = async () => {
    const link = `${window.location.origin}${router.pathname}?items=${buildItemsQuery(productos)}`;
    try {
      await navigator.clipboard.writeText(link);
      setSnackbarMessage('¡Link copiado! Ya podés compartirlo.');
    } catch (err) {
      setSnackbarMessage('No se pudo copiar el link.');
    }
    setShowSnackbar(true);
  };

  return {
    mobile,
    loadingProductos,
    productos,
    total,
    showSnackbar,
    snackbarMessage,
    setShowSnackbar,
    compartirCarrito,
  };
};

export default useHook;
